/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import Paper from '@mui/material/Paper';
import StyledTableCell from '../../../../../components/ui-elements/table/StyledTableCell';
import StyledTableRow from '../../../../../components/ui-elements/table/StyledTableRow';
import { Grid, IconButton } from "@mui/material";
import { useEffect } from 'react';
import { useState } from 'react';
import Loader from '../../../../../components/ui-elements/loader';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getAllAccountMappings } from '../../../../../store/reducers/mapping/mappingAction';
import DialogContainer from '../../../../../components/shared/Dialog/DialogContainer';
import { FaHistory } from 'react-icons/fa';
import MappingHistory from './MappingHistory';

const MappingsList = () => {
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();
    const mappingsList = useSelector(state => state.mapping.mappings);
    const [selectedMapping, setselectedMapping] = useState({});
    const [openHistory, setopenHistory] = useState(false);
    const handleCloseDialog = () => {
         setopenHistory(false);
    }

    const fetchMappings = useCallback(async () => {
        setLoading(true);
        try {
            await dispatch(getAllAccountMappings()).unwrap();
            setLoading(false);
        } catch (error) {
            setLoading(false);
        }
    }, [dispatch]);

    useEffect(() => {
        fetchMappings();
    }, [fetchMappings]);

    return (
        <>
            {!loading ? <>
                <Grid container justify="center">
                    <Grid xs={12} sm={6} md={3} style={{ marginBottom: '20px' }}>

                    </Grid>
                    <Grid xs={12} sm={12} md={12}>

                        <TableContainer component={Paper}>
                            <Table sx={{ minWidth: 700 }} aria-label="customized table">
                                <TableHead>
                                    <StyledTableRow>
                                        <StyledTableCell label="GetChkd ID" />
                                        <StyledTableCell label="User ID" />
                                        <StyledTableCell label="Application Name" />
                                        <StyledTableCell label="Identity Provider Name" />
                                        <StyledTableCell label=" " />

                                    </StyledTableRow>
                                </TableHead>
                                <TableBody>
                                    {mappingsList?.Records?.length > 0 && mappingsList?.Records?.map((row) => (
                                        <React.Fragment key={row.id}>

                                            <StyledTableRow >
                                                <StyledTableCell label={row.getChkdID} />
                                                <StyledTableCell label={row.appUserID} />

                                                <StyledTableCell label={row.applicationName} />
                                                <StyledTableCell label={row.authProviderName} />
                                                <StyledTableCell align="right"  >

                                                    <IconButton color='primary' style={{ marginRight: '30px' }} onClick={() => { setselectedMapping(row); setopenHistory(true) }}>
                                                        <FaHistory />
                                                    </IconButton>
                                                </StyledTableCell>
                                            </StyledTableRow>
                                        </React.Fragment>

                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Grid>
                </Grid>
            </> : (<Loader />)}
            <DialogContainer
                open={openHistory}
                handleClose={handleCloseDialog}
            >
                <MappingHistory
                    selectedMapping={selectedMapping}
                    handleClose={handleCloseDialog} />
            </DialogContainer>
        </>
    )

}

export default MappingsList;
